'use client';

import { CookieKeys, setClientCookie } from '@finn/ui-utils';
import { useSearchParams } from 'next/navigation';
import React, { useEffect } from 'react';

export const SideEffects: React.FC = () => {
  const searchParams = useSearchParams();
  const referrerCode: string | null = searchParams?.get('referrer-code');
  // Read referer-code from url and store in cookie
  useEffect(() => {
    if (referrerCode) {
      setClientCookie(CookieKeys.B2B_REFERRER_CODE, referrerCode, 30);
    }
  }, [referrerCode]);

  return null;
};
